import React from "react"
import { useParams } from "react-router-dom"
import MembersListing from "../../../components/Listing/MembersListing"

/**
 * Admin Members listing — global `/admin/members` and city-scoped
 * `/admin/cities/:cityId/members`.
 * List: GET /api/v1/admin/members (tabs All / Active / Inactive).
 * Summary: GET /api/v1/admin/members/users-summary → { all, active, inactive }.
 */
const AdminMembers = () => {
  const { cityId } = useParams()
  const isCityScoped = Boolean(cityId)
  const memberBasePath = isCityScoped
    ? `/admin/cities/${cityId}/members`
    : "/admin/members"

  return (
    <MembersListing
      documentTitle={
        isCityScoped
          ? "City Members | AMOK . EARTH Admin"
          : "Members | AMOK . EARTH Admin"
      }
      cityId={isCityScoped ? cityId : undefined}
      showKpi={!isCityScoped}
      showExport={!isCityScoped}
      showCityFilter={!isCityScoped}
      memberBasePath={memberBasePath}
      className={isCityScoped ? "admin-members--city" : ""}
    />
  )
}

export default AdminMembers
